import { combineReducers } from "redux"
import actionLogReducer from "./actionlog/actionLogReducer"
import alerts from "./alert/reducer"
import bulkOperationsStatusReducer from "./bulk-operation/BulkOperationStatusReducer"
import calendarEventReducer from "./calendar-event/CalendarEventFormReducer"
import contactReducer from "./contact/reducers/reducer"
import { inventoryReducer } from "./inventory"
import { listingReducer } from "./listing"
import paymentProcessing from "./payment-processor/reducer"
import priceLevelListingReducer from "./price-level/PriceLevelListingReducer"
import orderAttemptReducer from "./price-list/orderAttemptReducer"
import priceListReducer from "./price-list/priceListReducer"
import reducer from "./pricing/reducers/reducer"
import { productReducer } from "./product/ProductReducer"
import { projectReducer } from "./project"
import { proposalReducer } from "./proposal"
import selectionReducer from "./selection/selectionReducer"

const rootReducer = combineReducers({
    pricingTableReducer: reducer,
    priceLevelListingReducer,
    priceListReducer,
    actionLogReducer,
    selectionReducer,
    orderAttemptReducer,
    contactReducer,
    calendarEventReducer,
    bulkOperationsStatusReducer,
    product: productReducer,
    listing: listingReducer,
    inventory: inventoryReducer,
    project: projectReducer,
    proposal: proposalReducer,
    paymentProcessing,
    alerts,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/state/rootReducer.ts